import { utilities } from '@cornerstonejs/core';
const { calibratedPixelSpacingMetadataProvider } = utilities;
export default function calibrateImageSpacing(imageId, renderingEngine, rowPixelSpacing, columnPixelSpacing) {
    if (!columnPixelSpacing) {
        columnPixelSpacing = rowPixelSpacing;
    }
    calibratedPixelSpacingMetadataProvider.add(imageId, {
        rowPixelSpacing,
        columnPixelSpacing,
    });
    const viewports = renderingEngine.getStackViewports();
    viewports.forEach((viewport) => {
        const imageIds = viewport.getImageIds();
        if (imageIds.includes(imageId)) {
            viewport.calibrateSpacing(imageId);
        }
    });
}
//# sourceMappingURL=calibrateImageSpacing.js.map